<template>
  <div>
    <div class="bottom-panel">
      <div @click="changeLauguage">
        <van-icon name="setting-o" />
        &nbsp;
        <span>{{ language }}</span>
      </div>
      <div>
        <div>
          <a href="javascript:void(0);" class="privacy-link" @click="goToPrivacyPolicy">
            {{ $t('view.login.privacyPolicy') }}
          </a>
        </div>
        <div>
          <a href="javascript:void(0);" class="privacy-link" @click="goToServicePolicy">
            {{ $t('view.login.serviceAgreement') }}
          </a>
        </div>
        <!-- <div>{{ $t('view.app.msg3') }}</div> -->
      </div>
      <div>{{ $t('view.app.msg4') }}</div>
    </div>
    <van-action-sheet v-model="languageShow" :actions="actions" @select="onSelectLanguage" />
  </div>
</template>

<script>
import LanguageEnum from '@/plugins/enum/LanguageEnum'
import * as LanguageService from '@/services/LanguageService'
export default {
  name: 'IndexBottom',
  data() {
    return {
      language: '',
      languageShow: false,
      actions:[]
    }
  },
  created(){
    this.getActions()
  },
  mounted(){
    this.$root.$on('set-language',this.getLanguage)
    this.getLanguage()
  },
  beforeUnmount(){
    // 移除事件监听器，避免内存泄漏
    this.$root.$off('set-language')
  },
  methods: {
    getActions(){
      for(let one of LanguageEnum.getList()){
        this.actions.push({name:one.text,val:one.value})
      }
    },
    onSelectLanguage(item){
      sessionStorage.setItem('language', item.val)
      this.$i18n.setLocale(item.val)
      this.language = item.name
      this.languageShow = false
      this.setLangeuage(item.val)
    },
    getLanguage(){
      this.language = LanguageEnum.getTextByVal(this.$i18n.locale)
    },
    changeLauguage(){
      this.languageShow = true
    },
    setLangeuage(language){
      const userId = sessionStorage.getItem('user_id')
      if(userId === null || typeof(userId) === undefined || userId.length === 0){
        this.$router.go(0)
        return
      }
      LanguageService.setLanguage({
        language:language,
        userId:userId
      }).then(()=>{
        this.$router.go(0)
      })
    },
    goToPrivacyPolicy() {
      this.$router.push('/privacyPolicy?activeTab=privacy')
    },
    goToServicePolicy() {
      this.$router.push('/privacyPolicy?activeTab=service')
    },
  }
}
</script>

<style scoped>

.bottom-panel {
  color: #fff;
  background: linear-gradient(
    135deg,
    #ffb347 0%,      /* 亮橙 */
    #ff8c00 30%,     /* 深橙 */
    #ff6600 60%,     /* 橙红 */
    #cc5200 100%     /* 暗橙棕 */
  );
  padding: 10px;
}

.bottom-panel>div:nth-child(1) {
  padding: 10px 0;
  text-align: center;
}

.bottom-panel>div:nth-child(2) {
  padding: 10px;
  font-size: 12px;
}

.bottom-panel>div:nth-child(2)>div {
  padding: 5px 15px;
}

.bottom-panel>div:nth-child(3) {
  font-size: 14px;
  height: 25px;
  line-height: 25px;
  text-align: center;
}
.privacy-link {
  /* font-size: 10px; */
  color: rgb(255, 255, 255);
  text-decoration: underline;
  /* margin-left: 4px; */
}
</style>